// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3BLr1","active":"NavigationItem_active__Q2HQR"};